<template>
    <template-card-v2 :one-log="oneLog" :linkedtype="linkedtype" :linkedid="linkedid">
        <template #icon>
            <CompassObject object="calendar" size="small" />
        </template>
        <template #label>
            <person-list-light
                :list="oneLog.staffs.params.list"
                placeholder-singular="Collaborateur"
                placeholder-plural="Collaborateurs"
            >
            </person-list-light>
        </template>

        <template #content>
            <div>
                <!-- DATE -->
                <div class="flex-level wp-10">
                    <div class="flex-column ovy-reset">
                        <span class="semibold lh-20 fs-3 flex-row ai-center">
                            <CompassIcon
                                size="small"
                                icon="calendar-fill"
                                class="mr-1"
                            ></CompassIcon>
                            {{ $l10n.__('Pour le') }}
                            {{ formatedDates[0] }}
                            <template v-if="formatedDates.length > 1">
                                {{ formatedDates[2] ? $l10n.__('à') : $l10n.__('au') }}
                                {{ formatedDates[1] }}
                            </template>
                        </span>

                        <div class="flex-level">
                            <CompassTag
                                v-if="oneLog.label"
                                type="dot"
                                size="small"
                                :color="!!oneLog.labelColor.length ? 'custom' : 'yellow'"
                                :custom-color="`#${oneLog.labelColor}`"
                                class="event-card-tag"
                            >
                                {{ oneLog.label }}
                            </CompassTag>
                        </div>
                    </div>
                </div>

                <div v-show="oneLog.canSee" class="event-card-content__container">
                    <!-- TITLE -->
                    <span
                        v-if="oneLog.title"
                        class="typographies-paragraph-medium-semibold event-card-title"
                        @click="previewEvent(oneLog)"
                    >
                        {{ oneLog.title }}
                    </span>
                    <!-- DESCRIPTION -->
                    <div
                        v-if="oneLog.description"
                        class="typographies-paragraph-medium-regular event-card__content rich-text-style"
                        v-html="oneLog.description"
                    />
                </div>
            </div>
        </template>
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment/moment';
const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        TemplateCardV2,
        PersonListLight,
    },
    mixins: [TimelineCardMixin],

    data() {
        return {
            lang: this.$parent.lang,
        };
    },
    computed: {
        ...mapStateUser({
            timezone: 'timezone',
            userForename: 'forename',
            userName: 'name',
        }),
        formatedDates() {
            return this.$filters.dateIntervalFormatter(
                this.oneLog.start,
                this.oneLog.end,
                this.oneLog.allDay ? 'NORMAL_DATE_WITH_DAY' : 'NORMAL_DATE_TIME_WITH_DAY',
                false,
            );
        },
    },
    methods: {
        previewEvent(onelog) {
            Agenda.preview(
                onelog.editableid,
                onelog.calendar,
                '',
                moment(onelog.start, 'X').tz(this.timezone).format('YYYY-MM-DD HH:mm:ss'),
                moment(onelog.end, 'X').tz(this.timezone).format('YYYY-MM-DD HH:mm:ss'),
                onelog.isRecurring,
                onelog.title,
                onelog.can_edit,
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.event-card {
    &-content__container {
        display: grid;
    }
    &-title {
        cursor: pointer;
    }
    &-tag {
        margin-bottom: var(--spacing-1);
    }
    &__content {
        margin: var(--spacing-0) 0 0;
    }
}
</style>
